import QashqoolLogo from "@/assets/images/qashqool-logo-light-slim.svg?react";
import { useState } from "react";
import AssignTutorPassword from "./AssignTutorPassword";
import ChooseTutotrSubdomain from "./ChooseTutotrSubdomain";
import OTPverification from "./OTPverification";
import PortalDataCard from "./PortalDataCard";
import "./TutorRegistration.css";
import TutorRegistrationProgressBar from "./TutorRegistrationProgressBar";
import TutorRegistrationStepOne from "./TutorRegistrationStepOne";
import UploadTutorImage from "./UploadTutorImage";

export interface TutorFormDataI {
  name: string;
  phone: string;
  whatsapp: string;
  email: string;
  password: string;
  subject: string;
  other_subject: string;
  other_subject_lang: string;
  logo: string;
  profile_pic: string;
  subdomain: string;
  otp: string;
  is_new: boolean;
}
const TutorRegistration = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    whatsapp: "",
    email: "",
    password: "",
    subject: "",
    other_subject: "",
    other_subject_lang: "",
    logo: "https://eliteacademymedia.s3.us-east-1.amazonaws.com/placeholder-profile-image-2.png",
    profile_pic:
      "https://eliteacademymedia.s3.us-east-1.amazonaws.com/placeholder-profile-image-2.png",
    subdomain: "",
    otp: "",
    is_new: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNext = () => setStep(step + 1);
  const handlePrev = (x?: number) => setStep(x ?? step - 1);

  console.log("step", step);

  return (
    <div className="w-full flex items-center justify-center bg-teal-50 min-h-screen">
      <div className="container mx-auto mt-4 pb-8 px-4">
        <QashqoolLogo className="mx-auto my-5 size-40" />
        <TutorRegistrationProgressBar step={step} />
        <div className="bg-white p-6 rounded-2xl shadow-lg border md:max-w-1/2 md:mx-auto">
          {step === 1 && (
            <TutorRegistrationStepOne
              formData={formData}
              setFormData={setFormData}
              handleChange={handleChange}
              handleNext={handleNext}
            />
          )}

          {step === 2 && (
            <OTPverification
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handlePrev={handlePrev}
            />
          )}

          {step === 3 && (
            <AssignTutorPassword
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handlePrev={handlePrev}
            />
          )}

          {step === 4 && (
            <UploadTutorImage
              step={step}
              title="يرجى رفع صورة شخصية (إختياري)"
              imgType="profile_pic"
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handlePrev={handlePrev}
            />
          )}

          {step === 5 && (
            <UploadTutorImage
              step={step}
              title="يرجى رفع لوجو للمنصة (إختياري)"
              imgType="logo"
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handlePrev={handlePrev}
            />
          )}

          {step === 6 && (
            <ChooseTutotrSubdomain
              formData={formData}
              handleChange={handleChange}
              handleNext={handleNext}
              handlePrev={handlePrev}
            />
          )}

          {step === 7 && <PortalDataCard formData={formData} />}
        </div>
      </div>
    </div>
  );

  // return (
  //   <div className="container tr-container mt-5 pb-5">
  //     <TutorRegistrationProgressBar step={step} />

  //     <div className="card tr-card p-4 rounded-ea">
  //       {step === 1 && (
  //         <TutorRegistrationStepOne
  //           formData={formData}
  //           setFormData={setFormData}
  //           handleChange={handleChange}
  //           handleNext={handleNext}
  //         />
  //       )}

  //       {step === 2 && (
  //         <OTPverification
  //           formData={formData}
  //           setFormData={setFormData}
  //           handleNext={handleNext}
  //           handlePrev={handlePrev}
  //         />
  //       )}

  //       {step === 3 && (
  //         <AssignTutorPassword
  //           formData={formData}
  //           setFormData={setFormData}
  //           handleNext={handleNext}
  //           handlePrev={handlePrev}
  //         />
  //       )}

  //       {step === 4 && (
  //         <UploadTutorImage
  //           step={step}
  //           title="يرجى رفع صورة شخصية (إختياري)"
  //           imgType="profile_pic"
  //           formData={formData}
  //           setFormData={setFormData}
  //           handleNext={handleNext}
  //           handlePrev={handlePrev}
  //         />
  //       )}

  //       {step === 5 && (
  //         <UploadTutorImage
  //           step={step}
  //           title="يرجى رفع لوجو للمنصة (إختياري)"
  //           imgType="logo"
  //           formData={formData}
  //           setFormData={setFormData}
  //           handleNext={handleNext}
  //           handlePrev={handlePrev}
  //         />
  //       )}

  //       {step === 6 && (
  //         <ChooseTutotrSubdomain
  //           formData={formData}
  //           handleChange={handleChange}
  //           handleNext={handleNext}
  //           handlePrev={handlePrev}
  //         />
  //       )}

  //       {step === 7 && <PortalDataCard formData={formData} />}
  //     </div>
  //   </div>
  // );
};

export default TutorRegistration;
